import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { Box, Button, DialogActions, DialogContent, Grid, MenuItem, TextField } from '@mui/material';
import { MuiColorInput, MuiColorInputValue } from 'mui-color-input'
import { ModalActionProps } from 'models/AutoModals';
import countries from 'config/countries';
import { PortModel } from 'models/PortModel';
import auth from 'recoil/atoms/auth';


type PortDialogProps = {
    port?: PortModel,
    create?: boolean,
} & ModalActionProps<PortModel>

const PortDialog = ({ create, onFinish, port }: PortDialogProps) => {
    const my = useRecoilValue(auth);
    const {t} = useTranslation();
    const [color, setColor] = React.useState<MuiColorInputValue>(port?.color || '#1976d2')

    const submit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        const data = Object.fromEntries(new FormData(event.currentTarget).entries()) as unknown as PortModel;

        onFinish({
            ...port,
            ...data,
        });
    };

    return (
        <Box component="form" onSubmit={submit}>
            <DialogContent>
                <TextField
                    autoFocus
                    id="name"
                    name="name"
                    label={t('name')}
                    fullWidth
                    required
                    defaultValue={port?.name}
                />

                <TextField
                    id="code"
                    name="code"
                    label={t('code')}
                    fullWidth
                    defaultValue={port?.code}
                />

                <Grid container spacing={2}>
                    <Grid item xs={port?.isLoading ? 6 : 12}>
                        <TextField
                            select
                            id="country"
                            name="country"
                            label={t('country')}
                            defaultValue={port?.country}
                            fullWidth
                        >
                            {Object.entries(countries).map(([c, n]) => <MenuItem key={c} value={c}>{n}</MenuItem>)}
                        </TextField>
                    </Grid>
                    {!!port?.isLoading &&
                    <Grid item xs={6}>
                        <MuiColorInput
                            name="color"
                            label={t('color')}
                            value={color}
                            onChange={setColor}
                            format="hex"
                            isAlphaHidden
                        />
                    </Grid>
                    }
                </Grid>
            </DialogContent>

            {my.permissions.has(create ? 'ports create' : 'ports update') &&
                <DialogActions>
                    <Button type="submit">{create ? 'Add' : 'Save'}</Button>
                </DialogActions>
            }
        </Box>
    );
};

export default PortDialog;
